import { getDBContentCollectionsWithAssociatedItems } from '../utils/collections';
import { CollectionTypes } from '~/types/adamTypes';

import { getServices } from '~/db/services';

import type { NomadDB } from '~/db/NomadDB';

export const getIsAppInstalled = async (
  db: NomadDB,
  contents: UserContent[]
) => {
  const downloadableContents = contents.filter(
    (content) => content.type !== UserContentType.UnDownloadedContent
  );

  const { importsService } = getServices(db);

  const importsData = await importsService.findAll();

  // CHECK USER CONTENTS
  const neededInstalledContents = getDBContentCollectionsWithAssociatedItems();
  const installedContents = downloadableContents.filter(
    ({ id: libraryBookId }) => {
      const imported = importsData.filter(
        (item) =>
          item.libraryBookId === libraryBookId &&
          neededInstalledContents.includes(item.collection)
      );
      return imported.length === neededInstalledContents.length; // trophies has a librarybookid too
    }
  );

  if (installedContents.length !== downloadableContents.length) {
    return false;
  }

  // CHECK COMMON
  const otherNeededCollections = [
    CollectionTypes.Challenges,
    CollectionTypes.Recommendations,
    CollectionTypes.RecommendationParameters,
    CollectionTypes.Library,
    CollectionTypes.LibraryBooks,
    CollectionTypes.Progressions,
    CollectionTypes.Trophies,
    CollectionTypes.Media,
    CollectionTypes.Assessments,
    CollectionTypes.CoachingStats,
    CollectionTypes.Friends,
    CollectionTypes.MyFutureBoxes,
    CollectionTypes.SponsorInfos,
    CollectionTypes.Events,
  ];

  const otherNeededCollectionsInstalled = importsData.filter(
    (item) =>
      otherNeededCollections.includes(item.collection) &&
      item.libraryBookId === ''
  );
  if (
    otherNeededCollectionsInstalled.length !== otherNeededCollections.length
  ) {
    return false;
  }
  // So far, everything seems to be okay. :)
  return true;
};
